import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react'
import { ProcessFlowDiagramBuilderContext } from 'features/processFlowDiagrams/contexts/ProcessFlowDiagramBuilderContext'
import React, { useContext } from 'react'
import { PfdEdgeProps } from 'types'

import {
  DEFAULT_EDGE_STROKE_WIDTH,
  EDGE_LABEL_BG_STYLE,
  EDGE_LABEL_STYLE,
  getEdgeSelectionStyle,
} from './SolidLine'
import { SwapEdgeButton } from './SwapEdgeButton'

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {
    strokeWidth: 1,
    stroke: 'gray',
    strokeDasharray: '5 5',
  },
  markerEnd,
  markerStart,
  data,
}: PfdEdgeProps) {
  const { selectedEdge } = useContext(ProcessFlowDiagramBuilderContext)
  const selected = selectedEdge?.id === id
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    stepPosition: 1,
    borderRadius: 0,
    centerX: targetX,
  })

  const baseStyle: React.CSSProperties = {
    ...style,
    strokeWidth: data?.strokeWidth ?? DEFAULT_EDGE_STROKE_WIDTH,
  }
  const edgeStyle = getEdgeSelectionStyle(selected, baseStyle)

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
        style={edgeStyle}
        label={data?.label}
        labelStyle={data?.label ? EDGE_LABEL_STYLE : undefined}
        labelBgStyle={data?.label ? EDGE_LABEL_BG_STYLE : undefined}
        labelBgPadding={data?.label ? [4, 6] : undefined}
        labelX={data?.label ? labelX : undefined}
        labelY={data?.label ? labelY : undefined}
      />
      {!data?.confirmedEdge && (
        <EdgeLabelRenderer>
          <SwapEdgeButton labelX={labelX} labelY={labelY} id={id} />
        </EdgeLabelRenderer>
      )}
    </>
  )
}
